import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectTickets = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.dTickets,
);

export const selectTicketsFilters = createDraftSafeSelector(
  selectTickets,
  (state) => state.filters,
);

export const selectTicketsDetailItem = createDraftSafeSelector(
  selectTickets,
  (state) => state.detailItem,
);
